import React, { useEffect, useState } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import ResetPassword from '../../../components/ResetPassword'
import resetPasswordValidation from './resetPasswordValidation'
import getResetToken from './resetToken'
import useForm from '../useForm'
import { authApi } from '../../../api/apiNew'

const ResetPasswordContainer = () => {
	const history = useHistory()
	const { hash } = useLocation()
	const [token] = useState(() => getResetToken(hash))

	const [isPassShow, setIsPassShow] = useState(false)
	const [status, setStatus] = useState({
		message: '',
		isLoading: false,
	})
	const [values, setValues] = useState({
		password: '',
		repeatPassword: '',
	})
	const [errors, setErrors] = useState({
		password: '',
		repeatPassword: '',
	})

	useEffect(() => {
		document.title = 'Сброс пароля | Kinopoisk Api Unofficial'
	}, [])

	// the token is kept in state, so the fragment can be removed from the address bar and from analytics hits
	useEffect(() => {
		if (hash) {
			history.replace({ pathname: '/reset-password' })
		}
	}, [])

	useEffect(() => {
		if (status.message === 'ok') {
			history.push({
				pathname: '/signin',
			})
		}
	}, [status.message])

	const setPassShow = () => {
		setIsPassShow(!isPassShow)
	}

	const handleSubmit = e => {
		e.preventDefault()
		setStatus(prevState => ({
			...prevState,
			isLoading: true,
		}))

		authApi
			.confirmPasswordReset({ token, ...values })
			.then(res => {
				setStatus(prevState => ({
					...prevState,
					message: res.status === 200 ? 'ok' : '',
				}))
			})
			.catch(err => {
				setStatus(prevState => ({
					...prevState,
					message: err.response?.data?.message || 'Что-то пошло не так',
				}))
			})
			.finally(() => {
				setStatus(prevState => ({
					...prevState,
					isLoading: false,
				}))
			})
	}

	const { handleChange, disabled } = useForm(
		resetPasswordValidation,
		values,
		errors,
		setValues,
		setErrors
	)

	return (
		<ResetPassword
			hasToken={Boolean(token)}
			isPassShow={isPassShow}
			setPassShow={setPassShow}
			handleSubmit={handleSubmit}
			handleChange={handleChange}
			values={values}
			errors={errors}
			disabled={disabled}
			status={status}
		/>
	)
}

export default ResetPasswordContainer
